module.exports = require("promise/lib/es6-extensions.js");


//////////////////
// WEBPACK FOOTER
// external "promise/lib/es6-extensions.js"
// module id = 44
// module chunks = 0